module.exports = __webpack_public_path__ + "img/GH.55ee6f39.svg";